import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class ShowcaseReviewReplyDto
*  Ответ магазина.
*/
export class ShowcaseReviewReplyDto extends ActiveModel {

/**
  * text
  * Текст ответа.
  */
  @ActiveField('')
  text: string = ''


/**
  * created
  * Дата ответа.
  */
  @ActiveField('')
  created: string = ''
}
